import {
  OPERATIONS,
  SERVICE_COS,
  INCORRECT_ENTRY,
  ALREADY_EXISTS,
  EMPTY,
  MAIL_FORMAT_RE
} from './contants.js';
import { isEmptyObject } from "utils/index";
import { currencyData } from './currency.js';
import { getLocationForCountry } from "services/bulkUpload";
import { getDetailsByEmail } from 'services/index.js';
import _ from 'lodash';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const initialUserDetails = {
      firstName: "",
      lastName: "",
      isActiveWorker: true,
      isManager: false,
      isApprover: false,
      email: "",
      phone: "",
      agency: "",
      otherId: "",
      billRate: "",
      currency: "",
      jobRole: "",
      jobDepartment: OPERATIONS,
      timezone: {},
      costCenter: "",
      product:"",
      function:SERVICE_COS.function,
      costCenterId: "",
      productId:"",
      functionId:SERVICE_COS.id,
      approvingManager: [],
      pin: "",
      isNoEmail: true,
      jobType: "",
      operationalBuilding:[],
      operationalDistrict:[],
      managerId: "",
      country: "",
      expirationDate: "",
      workerId: "",
      alternateCountry: "",
      alternateCountryCode: ""
};

export const initialDisableState =  Object.keys(initialUserDetails).reduce((acc, key) => {
  acc[key] = false; // Set each field's disabled state to false (enabled)
  if(key === "email"){
    acc[key] = true; 
  }
  return acc;
}, {})


export const getWorkerFormData = (workerDocument, user, approveForMgr) =>{
  return {
    firstName: workerDocument?.firstName,
    lastName: workerDocument?.lastName,
    isActiveWorker: workerDocument?.isActiveWorker,
    isManager: workerDocument.isManager ? workerDocument.isManager : false ,
    isApprover: workerDocument.isApprover ? workerDocument.isApprover : false,
    email: workerDocument.email ? workerDocument.email : "",
    phone: workerDocument.phone ? workerDocument.phone : "",
    agency: workerDocument.agency ? workerDocument.agency : "",
    otherId: workerDocument.otherId ? workerDocument.otherId : "",
    billRate: workerDocument.billRate ? workerDocument.billRate : "",
    currency: workerDocument.currency ? workerDocument.currency : "",
    jobRole: workerDocument.jobRole ? workerDocument.jobRole : null,
    jobDepartment: workerDocument.jobDepartment ? workerDocument.jobDepartment : "",
    timezone: workerDocument.timezone ? workerDocument.timezone : {},
    costCenter: workerDocument.costCenter ? workerDocument.costCenter : "",
    product: workerDocument.product ? workerDocument.product : "",
    function: workerDocument.function ? workerDocument.function : SERVICE_COS.function,
    costCenterId: workerDocument.costCenterId ? workerDocument.costCenterId : "",
    productId: workerDocument.productId ? workerDocument.productId : "",
    functionId: workerDocument.functionId ? workerDocument.functionId : SERVICE_COS.id,
    approvingManager: workerDocument.approvingManager ? workerDocument.approvingManager : [],
    pin: workerDocument.pin ? workerDocument.pin : "",
    isNoEmail: workerDocument.isNoEmail ? workerDocument.isNoEmail : false,
    jobType: workerDocument.jobType ? workerDocument.jobType : "",
    operationalBuilding: [].concat(workerDocument.operationalBuilding || []),
    operationalDistrict: [].concat(workerDocument.operationalDistrict || []),
    managerId: workerDocument.managerId ? workerDocument.managerId : "",
    managerEmail: workerDocument.managerEmail ? workerDocument.managerEmail : "",
    managerFirstName: workerDocument.managerFirstName ? workerDocument.managerFirstName : "",
    managerLastName: workerDocument.managerLastName ? workerDocument.managerLastName : "",
    country: workerDocument.country ? workerDocument.country : "",
    countryCode: workerDocument.countryCode ? workerDocument.countryCode : "",
    alternateCountry: workerDocument.alternateCountry ? workerDocument.alternateCountry : "",
    alternateCountryCode: workerDocument.alternateCountryCode ? workerDocument.alternateCountryCode : "",
    expirationDate: workerDocument.expirationDate ? workerDocument.expirationDate : "",
    workerId: workerDocument.workerId ? workerDocument.workerId : "",
  }
}

export const getManagerOptions = (managersList, approveForMgr, user, workerData) =>{
  const managerOptions = [];
  const approvingMngrOptions = [];
  let managerId ;
  if(!isEmptyObject(user)){
    managerId = user?.workerId;
  }
  if(workerData?.managerId) {
    managerId = workerData?.managerId;
  }
  if(!isEmptyObject(approveForMgr)){
    managerId = approveForMgr?.managerId;
  }
  const selectedManagerCountry = managersList.filter(item=>item.managerId===managerId);
  managersList.map(item=>{
    // for manager look up dropdown options
    if(item?.managerCountry===selectedManagerCountry[0]?.managerCountry){
      managerOptions.push(item);
    }
    // for approving manager dropdown options
    if(item.managerId!==managerId){
      approvingMngrOptions.push(item);
    }
  });
  return {managerOptions, approvingMngrOptions};
}

export const getCountriesOptions = (countriesList, approveForMgr, user, workerData) => {
  let existingCountry = workerData?.country;

  if(!isEmptyObject(user)){
    existingCountry = user?.country;
  }
  if(!isEmptyObject(approveForMgr)){
    existingCountry = approveForMgr?.country;
  }

  if (existingCountry) {
    countriesList = countriesList.filter(
      (item) => item?.countryName != existingCountry
    );
  }
  return [...countriesList];
}

export const getCurrencyOptions = () => {
  let mymap = new Map();
  return currencyData.filter((el) => {
    const val = mymap.get(el.currency_code);
    if (val) {
      if (el.id < val) {
        mymap.delete(el.currency_code);
        mymap.set(el.currency_code, el.country);
        return true;
      } else {
        return false;
      }
    }
    mymap.set(el.currency_code, el.country);
    return true;
  });
}

// fetches location collection
export const getLocations =  (worker) => {
  return new Promise(async (res, rej) => {
  try {
    let totalDistrictsList = [];
    let activityEnabledList = [];
    let sbsEnabledList = [];
    let transportEnabledList = [];
    let crozierEnabledList = [];
    let securebaseEnableList = [];
    let oneilEnableList = [];
    const data = await  getLocationForCountry(worker?.countryCode, worker?.alternateCountryCode);
    totalDistrictsList = data ? [...data] : [];
    data && data.map((record) => {
      const { district, buildings={} } = record || {};
      let buildingEnabled = false;
      let sbsEnabled = false;
      let transportEnabled = false;
      let crozierEnabled = false;
      let securebaseEnabled = false;
      let oneilEnabled = false;

      // loop through buildings inside ditrsict record
      for(const key in buildings){
          const buildingInfo = buildings[key];
          if(buildingInfo.activityEnabled){
            buildingEnabled = true;
          }
          if(buildingInfo.sbsEnabled === true){
            sbsEnabled = true;
          }
          if(buildingInfo.transportEnabled === true){
            transportEnabled = true;
          }
          if(buildingInfo.crozierEnabled === true && buildingInfo.activityEnabled === true){
            crozierEnabled = true;
          }
          if(buildingInfo.sbEnabled === true){
            securebaseEnabled = true;
          }
          if(buildingInfo.wms === 'LTP'){
            oneilEnabled = true;
          }
      }

      if(buildingEnabled){
        activityEnabledList.push({...record});
      }
      if(sbsEnabled){
        sbsEnabledList.push({...record});
      }
      if(transportEnabled){
        transportEnabledList.push(district);
      }
      if(crozierEnabled){
        crozierEnabledList.push(({...record}));
      }
      if(securebaseEnabled){
        securebaseEnableList.push(({...record}));
      }
      if(oneilEnabled){
        oneilEnableList.push(({...record}));
      }
    })

    console.log("getLocations", activityEnabledList.length, transportEnabledList.length);
    res( {
      totalDistrictsList,
      activityEnabledList,
      sbsEnabledList,
      transportEnabledList,
      crozierEnabledList,
      securebaseEnableList,
      oneilEnableList
    })
  } catch(error){
    console.log("getLocations error", error);
    rej({})
  }
})
}

export const validateEmail = async (email, empId) => {
  try {
    // If email is empty, return empty message
    if (!email) return { error: false, message: EMPTY };

    // Check if the email format is valid
    if (!MAIL_FORMAT_RE.test(email)) {
      return { error: true, message: INCORRECT_ENTRY };
    }

    // Check if the email already exists for another worker
    const doc = await getDetailsByEmail(email);
    if (doc && (!empId || doc.data().workerId !== empId)) {
      return { error: true, message: ALREADY_EXISTS };
    }

    return { error: false, message: EMPTY };
  } catch (error) {
    console.error("validateEmail error:", error);
    throw new Error("An error occurred while validating the email");
  }
};

export const permWorkerDisableFields = {
        firstName: true,
        lastName: true,
        email: true,
        isNoEmail: true,
        phone: true,
        timezone: true,
        jobRole: true,
        jobDepartment: true,
        jobType: true,
        managerId: true,
        isActiveWorker: true,
        costCenter: true,
        product: true,
        function: true,
        agency: true,
        otherId: true,
        expirationDate: true
}

export const beelineWorkerDisableFields = {
  firstName: true,
        lastName: true,
      //  email: true,
      //  isNoEmail: true,
      //  phone: true,
      //  timezone: true,
      //  jobRole: true,
      //  jobDepartment: true,
      //  jobType: true,
        managerId: true,
        isActiveWorker: true,
      //  costCenter: true,
      //  product: true,
      //  function: true,
      //  agency: true,
        otherId: true,
        expirationDate: true
}

  // Function to compare workerForm with workerDocument (subset comparison)
export const isFormChanged = (workerForm, workerDocument) => {
  const workerFormKeys = Object.keys(workerForm);
    let hasChanges = false;

    // Iterate over workerForm keys and compare with workerDocument
    for (let key of workerFormKeys) {
      // If fields are different, log the difference
      if (workerDocument[key] && !_.isEqual(workerForm[key], workerDocument[key])) {
        // console.log(`Field changed: ${key}`);
        // console.log(`workerForm: ${JSON.stringify(workerForm[key])}`);
        // console.log(`workerDocument: ${JSON.stringify(workerDocument[key])}`);
        hasChanges = true; // Mark that there are changes
      }
    }

    return hasChanges; // Return true if there are changes
  }

export const IMTImeRoles = [ "Supervisor", "Worker" ];

export const mealOptions = [
  "30 mins",
  "45 mins",
  "60 mins",
  "90 mins",
  "120 mins",
];

export const dayHoursOptions = [
  "0 Hour",
  "0.5 Hours",
  "1 Hour",
  "1.5 Hours",
  "2 Hours",
  "2.5 Hours",
  "3 Hours",
  "3.5 Hours",
  "4 Hours",
  "4.5 Hours",
  "5 Hours",
  "5.5 Hours",
  "6 Hours",
  "6.5 Hours",
  "7 Hours",
  "7.5 Hours",
  "8 Hours",
  "8.5 Hours",
  "9 Hours",
  "9.5 Hours",
  "10 Hours",
  "10.5 Hours",
  "11 Hours",
  "11.5 Hours",
  "12 Hours",
 ];

export const weekHoursOptions = [
  "0 Hour",
  "1 Hour",
  "2 Hours",
  "3 Hours",
  "4 Hours",
  "5 Hours",
  "6 Hours",
  "7 Hours",
  "8 Hours",
  "9 Hours",
  "10 Hours",
  "11 Hours",
  "12 Hours",
  "13 Hours",
  "14 Hours",
  "15 Hours",
  "16 Hours",
  "17 Hours",
  "18 Hours",
  "19 Hours",
  "20 Hours",
  "21 Hours",
  "22 Hours",
  "23 Hours",
  "24 Hours",
  "25 Hours",
  "26 Hours",
  "27 Hours",
  "28 Hours",
  "29 Hours",
  "30 Hours",
  "31 Hours",
  "32 Hours",
  "33 Hours",
  "34 Hours",
  "35 Hours",
  "36 Hours",
  "37 Hours",
  "38 Hours",
  "39 Hours",
  "40 Hours",
  "41 Hours",
  "42 Hours",
  "43 Hours",
  "44 Hours",
  "45 Hours",
  "46 Hours",
  "47 Hours",
  "48 Hours",
  "49 Hours",
  "50 Hours",
  "51 Hours",
  "52 Hours",
  "53 Hours",
  "54 Hours",
  "55 Hours",
  "56 Hours",
  "57 Hours",
  "58 Hours",
  "59 Hours",
  "60 Hours",
 
 ];

// Helper function to check if start is before end
export const isValidSlot = (start, end) => {
  const startTime = dayjs(start, "hh:mma");
  const endTime = dayjs(end, "hh:mma");
  return startTime.isBefore(endTime);
};

export const findOverlappingSlots = (slots) => {
  const errors = [];
  // Sort the slots based on start time
  const sortedSlots = slots.map((slot, index) => ({ ...slot, index }))  // Preserve the original index
    .sort((a, b) => dayjs(a.start, "hh:mma").isBefore(dayjs(b.start, "hh:mma")) ? -1 : 1);

  // Check for overlaps between each pair of slots
  for (let i = 0; i < sortedSlots.length - 1; i++) {
    const currentSlotEnd = dayjs(sortedSlots[i].end, "hh:mma");
    const nextSlotStart = dayjs(sortedSlots[i + 1].start, "hh:mma");

    // If the current slot's end time is after the next slot's start time, they overlap
    if (currentSlotEnd.isAfter(nextSlotStart)) {
      // Report error on both slots that are overlapping
      errors.push({ slotIndex: sortedSlots[i].index, message: `Slot ${sortedSlots[i].index + 1} overlaps with Slot ${sortedSlots[i + 1].index + 1}` });
      errors.push({ slotIndex: sortedSlots[i + 1].index, message: `Slot ${sortedSlots[i + 1].index + 1} overlaps with Slot ${sortedSlots[i].index + 1}` });
    }
  }
  return errors;
}

export const skpRegionRoles = ["Worker", "Project Manager", "Supervisor","Administrator"];

export const getModifiedRegions = (updatedData, originalData, regions) => {

    let changedRegions = {};
    let isEnabled = false;
    const systems = regions && regions.systems &&  regions.systems.length>0 ? regions.systems : [];

    systems.forEach(activityFamily => {
      const updatedRegions = updatedData?.selectedRegions?.[activityFamily] || [];
      const originalRegions = originalData?.selectedRegions?.[activityFamily] || [];
      const allRegions = regions[activityFamily] || [];
      allRegions.length > 0 && allRegions.forEach(region => {
          const updatedRegionData = updatedData?.[activityFamily]?.[region] || {};
          const originalRegionData = originalData?.[activityFamily]?.[region] || {};
        if(updatedRegions.includes(region)){
          let data = {
            userId: updatedRegionData?.userId || "",
            activityFamilyId: activityFamily,
            region,
            isActive: true,
            id : updatedRegionData.id || ""
          }
          if(updatedRegionData?.role){
            data.role = updatedRegionData.role;
          }
          updatedRegionData.isActive = true;
          isEnabled= true;
          if(!originalRegions.includes(region) || 
              (originalRegions.includes(region) && 
              (originalRegionData.role !== updatedRegionData.role 
                || originalRegionData.userId !== updatedRegionData.userId
                || originalRegionData.isActive !== updatedRegionData.isActive))
          ){
            changedRegions[activityFamily] = {...(changedRegions[activityFamily]|| {}), [region]: {...data}};
            updatedRegionData.isActive = true;
            isEnabled= true;
          }       
        }else if(!updatedRegions.includes(region) && originalRegions.includes(region)){
          let data = {
            userId: originalRegionData?.userId || "",
            activityFamilyId: activityFamily,
            region,
            isActive: false,
            id : originalRegionData.id
          }
          if(originalRegionData?.role){
            data.role = originalRegionData.role;
          }
          changedRegions[activityFamily] = {...(changedRegions[activityFamily]|| {}), [region]: {...data}};
          updatedRegionData.isActive = false;
        }
      })

    })


    return {updatedRegions: changedRegions, updatedForm: updatedData,  isEnabled};

}

export const gdePermissionOpts = [
  {label:'View All Jobs', value:'viewAllJobs', enabled:false, role:'Data Entry'},
  {label:'Assign Job', value:'assignJob', enabled:false, role:'Data Entry'},
  {label:'Quality Check', value:'qualityCheck', enabled:false, role:'Data Entry'},
  {label:'Manually Transmit Job', value:'manuallyTransmitJob', enabled:false, role:'Data Entry'},
  {label:'View Productivity Reports', value:'viewProductivityReport', enabled:false, role:'Data Entry'}, 
  {label:'Require Quality Check', value:'requireQualityCheck', enabled:false, role:'Data Entry'},
  {label:'Search Template', value:'searchTemplate', enabled:false, role:'Data Entry'},
  {label:'Create Job', value:'createJob', enabled:false, role:'Data Entry'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role: 'Data Entry'},
  {label:'Edit/Cancel Job', value:'editJob', enabled:false, role:'Supervisor'},
  {label:'Create Template', value:'createTemplate', enabled:false, role:'Supervisor'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role:'Supervisor'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role:'Admin'},
  {label:'Smart Catalog', value: 'smartCatalog', enabled: false, role:'Super User'},
  {label:'Delete Box', value: 'deleteBox', enabled: false, role: 'Admin'}
]
